import {
  FEATURE_TOGGLE_NAME_DELIMITER,
} from './featureToggleConstants';
import {
  createImmutableMapFromArray,
} from '../../common/collection/collectionUtils';

function generateFeatureToggleNamesParamString(featureToggleNames) {
  return featureToggleNames.join(FEATURE_TOGGLE_NAME_DELIMITER);
}

function generateFeatureToggleMapElementTransformer(accMap, element, config) {
  const {propertyName} = config;

  accMap.set(element[propertyName], element.status || false);

  return accMap;
}

function generateFeatureToggleMap(rawFeatureToggleArray) {
  return createImmutableMapFromArray(
    rawFeatureToggleArray,
    {
      propertyName: 'name',
      transformer: generateFeatureToggleMapElementTransformer,
    }
  )
}

function extractFeatureToggleFromApiResponse(featureTogglesResponse, featureToggleName) {
  const foundFeatureToggle =
    featureTogglesResponse.data.data &&
    featureTogglesResponse.data.data.find(
      featureToggle => featureToggle.name === featureToggleName
    );

  return foundFeatureToggle && foundFeatureToggle.status;
}


export {
  generateFeatureToggleNamesParamString,
  generateFeatureToggleMap,
  extractFeatureToggleFromApiResponse,
  generateFeatureToggleMapElementTransformer,
};
